import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient'; // Import the Supabase client
import { GoalsIcon, UserIcon, ChatIcon, MealIcon, WorkoutIcon, HomeIcon, EntriesIcon } from "../../assets/icons/icons"; // Import icons
import './style.css';
import { useBrand } from '../../branding/BrandProvider';

export default function NavBar(props) {
    const { name: brandName, logos } = useBrand();
    const logoSrc = logos?.full || logos?.fullWhite;
    const logoAlt = brandName || 'Logo';
    // Nav Icon States
    const [isDashboard, setIsDashboard] = useState(false);
    
    const [isProgress, setIsProgress] = useState(false);
    const [isWorkout, setIsWorkout] = useState(false);
    const [isMeals, setIsMeals] = useState(false);
    const [isChat, setIsChat] = useState(false);
    const [isCoachDashboard, setIsCoachDashboard] = useState(false);

    const [isAuthenticated, setIsAuthenticated] = useState(false); // Check user login state
    const [isCoach, setIsCoach] = useState(false);

    const [isSideNav, setIsSideNav] = useState(true);

    useEffect(() => {
        const checkIsCoach = async (userId) => {
            if (!userId) return false;
            const { data, error } = await supabase
                .from('coach_accounts')
                .select('coach_id')
                .eq('coach_id', userId)
                .maybeSingle();
            if (error) return false;
            return !!data;
        };

        const checkAuthSession = async () => {
            const { data: sessionData } = await supabase.auth.getSession();
            setIsAuthenticated(!!sessionData.session); // Set isAuthenticated to true if a session exists
            const userId = sessionData?.session?.user?.id;
            setIsCoach(await checkIsCoach(userId));
        };

        checkAuthSession();

        const { data: authListener } = supabase.auth.onAuthStateChange(async (event, session) => {
            setIsAuthenticated(!!session); // Update auth state when user logs in or logs out
            const userId = session?.user?.id;
            setIsCoach(await checkIsCoach(userId));
        });

        return () => {
            authListener.subscription?.unsubscribe();
        };
    }, []);

    useEffect(() => {
        const currentPath = window.location.pathname;
        setIsDashboard(currentPath === '/');
        
        setIsProgress(currentPath === '/progress');
        setIsWorkout(currentPath === '/workout');
        setIsMeals(currentPath === '/meals');
        setIsChat(currentPath === '/chat');
        setIsCoachDashboard(currentPath === '/coach' || currentPath.startsWith('/coach/'));
    }, []);

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", checkMobile);
        checkMobile();
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return (
        <>
            {isMobile ? (
                <>
                    <div className="mobile-view">
                        <footer className="mobile-nav">
                            <button
                                className={`nav-icon-btn ${isDashboard ? 'mobile-nav-selected' : ''}`}
                                onClick={(e) => window.location.href = '/'}
                            >
                                <HomeIcon className="icon" />
                                {/* <img src={Logo} alt='logo' className="icon" /> */}
                            </button>
                            <button
                                className={`nav-icon-btn ${isProgress ? 'mobile-nav-selected' : ''}`}
                                onClick={(e) => window.location.href = '/progress'}
                            >
                                <GoalsIcon className="icon" />
                            </button>

                            { !isChat && (
                            <div className="entry-button-container">
                                <button className="entry-button" onClick={(e) => window.location.href = '/chat'}>
                                    <ChatIcon className="entry-icon" />
                                </button>
                            </div>
                            )}

                            <button
                                className={`nav-icon-btn ${isMeals ? 'mobile-nav-selected' : ''}`}
                                onClick={(e) => window.location.href = '/meals'}
                            >
                                <MealIcon className="icon" />
                            </button>
                            <button
                                className={`nav-icon-btn ${isWorkout ? 'mobile-nav-selected' : ''}`}
                                onClick={(e) => window.location.href = '/workout'}
                            >
                                <WorkoutIcon className="icon" />
                            </button>
                        </footer>
                    </div>
                </>
            ) : (
                <>
                    <header className="header-dashboard">
                        <nav className="web-nav">
                            <div className="logo-container" onClick={() => window.location.href = '/'}>
                                {logoSrc && <img src={logoSrc} alt={logoAlt} className="logo" />}
                            </div>
                            <div className="web-nav-icon-container">
                                <div>
                                    <div className={`icon-container ${isChat ? 'nav-selected' : ''}`} onClick={() => window.location.href = '/chat'}>
                                        <ChatIcon className="icon" />
                                        <span className={`icon-title ${isSideNav ? '' : 'display-none'}`}>Chat</span>
                                    </div>
                                    <div className={`icon-container ${isProgress ? 'nav-selected' : ''}`} onClick={() => window.location.href = '/progress'}>
                                        <GoalsIcon className="icon" />
                                        <span className={`icon-title ${isSideNav ? '' : 'display-none'}`}>Progress</span>
                                    </div>
                                    <div className={`icon-container ${isWorkout ? 'nav-selected' : ''}`} onClick={() => window.location.href = '/workout'}>
                                        <WorkoutIcon className="icon" />
                                        <span className={`icon-title ${isSideNav ? '' : 'display-none'}`}>Workout</span>
                                    </div>
                                    <div className={`icon-container ${isMeals ? 'nav-selected' : ''}`} onClick={() => window.location.href = '/meals'}>
                                        <MealIcon className="icon" />
                                        <span className={`icon-title ${isSideNav ? '' : 'display-none'}`}>Meals</span>
                                    </div>
                                    {isCoach && (
                                        <div className={`icon-container ${isCoachDashboard ? 'nav-selected' : ''}`} onClick={() => window.location.href = '/coach'}>
                                            <EntriesIcon className="icon" />
                                            <span className={`icon-title ${isSideNav ? '' : 'display-none'}`}>Coach</span>
                                        </div>
                                    )}
                                </div>
                                <div>
                                    {!isAuthenticated && (
                                        <div className='icon-container' onClick={() => window.location.href = '/login'}>
                                            <UserIcon className="icon" />
                                            <span className={`icon-title ${isSideNav ? '' : 'display-none'}`}>Login</span>
                                        </div>
                                    )}
                                    {/* <div className="give-container">
                                        <GiveIcon className='icon' />
                                        <span className={`icon-title ${isSideNav ? '' : 'display-none'}`}>Help CalmLeaf</span>
                                    </div> */}
                                </div>
                            </div>
                        </nav>
                    </header>
                </>
            )}
        </>
    );
}




